import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Switch } from '@mui/material';
import { candidateDetailsSelection } from '../../../Profile/CandidateDetails.selector';
import { selectUser } from 'oidc/user.selectors';
import { jobPreferncesActions } from '../store/JobPreferences.redux';
import { selectJobPreferencesData } from '../store/JobPreferences.selectors';
import { usePromiseTracker } from 'react-promise-tracker';
import { GridCellParams } from '@mui/x-data-grid-pro';
import { getEmployeeId } from '@AMIEWEB/Notification/Tasks/Common_v2/utils';

export const JobPreferenceNotificationXgridCell = (params: GridCellParams) => {
  /** Memoization prevents first level component from using hooks */
  return <JobPreferenceNotificationXgrid params={params} />;
};

export const JobPreferenceNotificationXgrid = ({ params }: { params: GridCellParams }) => {
  const dispatch = useDispatch();
  const isOff = false;
  const [notify, setNotify] = useState<boolean>(!isOff ?? true);
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
  const candidateDetails = useSelector(candidateDetailsSelection);
  const user = useSelector(selectUser);
  const { jobPreferencesData } = useSelector(selectJobPreferencesData);
  const { promiseInProgress: isCallingAPI } = usePromiseTracker({ area: 'job-preference-toggle', delay: 0 });

  const isUserRecruiterForCandidate = () => {
    return parseInt(getEmployeeId(user.userInfo)) === candidateDetails?.recruiter?.recruiterId;
  };

  const handleToggle = () => {
    const payload = {
      candidateId: candidateDetails?.travelerId.toString(),
      brandId: candidateDetails?.brandId.toString(),
      id: params?.id.toString(),
      isOff: !notify,
    };
    dispatch(jobPreferncesActions.toggleJobPreferenceNotificationAction(payload));
  };

  useEffect(() => {
    setIsAuthorized(isUserRecruiterForCandidate());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, candidateDetails]);

  useEffect(() => {
    if (params) {
      const prefData = jobPreferencesData?.find(pref => pref?.id === params?.id);
      if (prefData) {
        setNotify(prefData.isOff);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobPreferencesData]);

  return (
    <Grid>
      <Switch
        checked={!notify}
        disableRipple
        defaultChecked={!notify}
        disabled={(!isAuthorized || isCallingAPI) ?? true}
        onClick={handleToggle}
      />
    </Grid>
  );
};
